import dotenv from 'dotenv'
import { version } from '../../package.json'
dotenv.config()

const MAINNET = '_MAINNET'
const TESTNET = '_TESTNET'
const REACTAPP = 'REACT_APP_'

// Domains whitelist
const PRODUCTION_SITES = {
  testnet: ['info.test.energiswap.exchange'],
  mainnet: ['info.energiswap.exchange', 'localhost:3000'],
}

const w = typeof window !== 'undefined' && window
const isProduction = !!(w && w.location && PRODUCTION_SITES?.mainnet?.includes(w.location.host))
const getEnvironmentVar = env => env === 'VERSION' ? version : process.env[REACTAPP + env + (isProduction ? MAINNET : TESTNET)] || ''
export default getEnvironmentVar
